<div class="no-category-container">
	<section class="decision-panel">
		<div class="flex justify-content-between align-items-center gap-3 mb-3">
			<div>
				<h3 class="m-0">Ticket da categorizzare</h3>
				@if (currentTicket(); as ticket) {
					<span class="text-sm text-color-secondary">{{ ticket.ticket_code }}</span>
				}
			</div>
			<p-button icon="pi pi-history"
					  label="Storico"
					  severity="secondary"
					  [outlined]="true"
					  (onClick)="historyDrawerVisible.set(true)" />
		</div>

		<div class="card-stack">
			@if ( tickets().length === 0 ) {
				<div class="empty-state">
					<i class="pi pi-check-circle"></i>
					<h3 class="m-0">Non sono presenti altri ticket</h3>
				</div>
			} @else {
				@for (ticket of tickets(); track ticket.id; let i = $index){
					<p-card #ticketEl
							class="ticket-info absolute w-full h-full overflow-hidden surface-50"
							[attr.data-ticket-id]="ticket.id"
							[style.zIndex]="tickets().length - i"
							[style.transform]="stackTransform(i)"
							(pointerdown)="i === 0 && onDown($event, ticket)"
							(pointermove)="i === 0 && onMove($event)"
							(pointerup)="i === 0 && onUp()"
							(pointercancel)="i === 0 && onUp()">
							<ng-template #title>{{ticket.subject}}</ng-template>
							<ng-template #subtitle>
								{{ticket.last_inbound_at | date:'fullDate':'':'IT-it' }}
							</ng-template>
							<div class="ticket-summary">
								<div>
									<span class="summary-label">Mittente</span>
									<span class="summary-value">{{ ticket.initial_sender_email }}</span>
								</div>
							</div>
							<ng-template #footer>
								<div class="flex gap-3 mt-1">
									<p-button label="Altro"
											  severity="secondary"
											  class="w-full"
											  [outlined]="true"
											  styleClass="w-full"
											  (onClick)="startCommit(ticket, ticketEl.el.nativeElement, 'left'); $event.stopPropagation()" />
									<p-button label="Supporto"
											  severity="primary"
											  class="w-full"
											  [outlined]="true"
											  styleClass="w-full"
											  (onClick)="startCommit(ticket, ticketEl.el.nativeElement, 'right'); $event.stopPropagation()" />
								</div>
							</ng-template>
					</p-card>
				}
			}
		</div>
	</section>

	<p-divider layout="vertical" styleClass="category-divider" />

	<section class="mail-panel">
		@if (currentTicket(); as ticket) {
			<div class="mail-header">
				<div>
					<span class="text-sm text-color-secondary">Oggetto</span>
					<h3 class="m-0">{{ ticket.subject }}</h3>
				</div>
				<span class="text-sm text-color-secondary">
					{{ ticket.last_inbound_at | date:'short':'':'IT-it' }}
				</span>
			</div>
			<div class="mail-body" [innerHTML]="ticket.first_email_body"></div>
		} @else {
			<div class="empty-state">
				<i class="pi pi-inbox"></i>
				<h3 class="m-0">Nessuna email da leggere</h3>
			</div>
		}
	</section>
</div>

<p-drawer [(visible)]="historyDrawerVisible"
		  styleClass="border-0 border-round-left-xl no-category-history-drawer"
		  position="right"
		  [style]="{width: '28rem'}"
		  [modal]="false">

	<ng-template #header>
		<span class="font-bold uppercase">Storico categorizzazioni</span>
	</ng-template>

	<div class="history-drawer-content">
		<app-no-category-history type="OTHER"></app-no-category-history>
		<app-no-category-history type="SUPPORT"></app-no-category-history>
	</div>
</p-drawer>
